var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("document-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "documentTreeGrid",
        attrs: { context: _vm.context },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          refresh: _vm.refreshHandle
        }
      }),
      _c("document-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "documentWorkspace",
        attrs: { "parent-context": _vm.context },
        on: { back: _vm.backToList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }